import React from "react";
import {
  Wrap,
  Inner,
  Title,
  Script,
  PortraitWrap,
  PortraitFrame,
  PortraitImg,
  GoldLine,
  Text,
  Actions,
  PrimaryBtn,
} from "./QualitySectionStyles";

export default function QualitySection({
  title = "Calitatea la Ahava Cakes",
  script = "La Ahava Cakes, calitatea nu este un detaliu, ci fundamentul fiecărui produs.",
  imageSrc = null,
  imageAlt = "Ahava Cakes story",
  paragraphs = [
    "La Ahava Cakes, fiecare desert este pregătit artizanal, cu ingrediente naturale și fără premixuri sau adaosuri artificiale. Tocmai pentru că lucrăm proaspăt și cu atenție la detalii, stocurile sunt limitate și actualizate permanent. ",
    "Astfel, vă putem garanta nu doar gustul autentic, ci și prospețimea fiecărei prăjituri, tarte sau tort.",
  ],
  primaryCta = { label: "Vezi produse", onClick: null },
}) {
  return (
    <Wrap>
      <Inner>
        <Title>{title}</Title>
        <Script>{script}</Script>

        {imageSrc ? (
          <PortraitWrap aria-hidden="false">
            <PortraitFrame>
              <PortraitImg src={imageSrc} alt={imageAlt} loading="lazy" />
            </PortraitFrame>
          </PortraitWrap>
        ) : null}

        <GoldLine />

        {paragraphs.map((p, i) => (
          <Text key={i}>{p}</Text>
        ))}

        <Actions>
          <PrimaryBtn type="button" onClick={primaryCta?.onClick || undefined}>
            {primaryCta?.label}
          </PrimaryBtn>
        </Actions>
      </Inner>
    </Wrap>
  );
}
